module.exports = __webpack_public_path__ + "static/media/location.70b3b98d.svg";